import { useCallback } from 'react';
import get from 'lodash/get';
import { toast } from 'react-toastify';
import { useIntl } from 'react-intl';
import useUser from 'hooks/user/useUser';
import { formatGraphqlErrors } from 'utils/helpers';
import { useMutation } from '@apollo/client/react';
import { ResendVerificationEmailDocument } from 'graphql/generated/graphql';

const useSendVerificationEmail = (): [() => Promise<void>, boolean] => {
  const { formatMessage: __ } = useIntl();
  const [me] = useUser();
  const email = get(me, 'emails[0].address', null);
  const [sendVerificationAccountEmail, { loading }] = useMutation(ResendVerificationEmailDocument, {
    onCompleted: () => {
      toast.success(__({ id: 'verify_account.email_sent' }));
    },
    onError: (e) => toast.error(formatGraphqlErrors(e).message),
  });

  const handleSendVerificationEmail = useCallback(async () => {
    try {
      await sendVerificationAccountEmail({ variables: { email } });
    } catch {
      // onError has handled the error: with an onError option the mutation resolved under Apollo Client 2,
      // Apollo Client 4 rejects after calling it.
    }
  }, [email, sendVerificationAccountEmail]);

  return [handleSendVerificationEmail, loading];
};

export default useSendVerificationEmail;
